import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, Col, Form, FormGroup, Panel} from 'react-bootstrap';
import {Field, reduxForm} from 'redux-form';
import {InputField} from './InputField';
import {validation} from '../validation';
import Recaptcha from './Recaptcha';

const validate = validation({
    email: {
        required: true,
    },
});

@reduxForm({form: 'ForgotPassword', validate})
export default class ForgotPassword extends Component {
    static propTypes = {
        handleSubmit: PropTypes.func, // passed by redux-form
        captchaResponse: PropTypes.string,
        onCaptchaResponse: PropTypes.func,
    };

    componentWillReceiveProps(nextProps) {
        if (this.props.captchaResponse && !nextProps.captchaResponse) {
            this.recaptcha.reset();
        }
    }

    render() {
        const {captchaResponse, handleSubmit, onCaptchaResponse} = this.props;

        return (
            <Panel header={'Registration'}>
                <Form onSubmit={handleSubmit} style={{margin: 'auto', width: 600}} horizontal className="user-edit">
                    <Field type="text" name="email" component={InputField} label="Email" required autoComplete="off"/>
                    <FormGroup>
                        <Col mdOffset={3} md={9} style={{marginTop: 10}}>
                            <Recaptcha
                                ref={c => this.recaptcha = c}
                                verifyCallback={onCaptchaResponse}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup>
                        <Col mdOffset={3} md={9}>
                            <Button type="submit" bsStyle="primary" className="loginBtn" disabled={!captchaResponse}>{'Reset'}</Button>
                        </Col>
                    </FormGroup>
                </Form>
            </Panel>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ForgotPassword.js